import _toConsumableArray from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pagination from '@/views/mixin/page';
import customContainerHeader from '@/components/custom-container-header';
import { getRoutes, AddOrModify, Delete, saveModifySave, GetReportByRoleId, SaveReportPermission } from '@/api/sys.role';
import { cloneDeep } from 'lodash';
export default {
  name: 'ManagerRole',
  mixins: [pagination],
  components: {
    customContainerHeader: customContainerHeader
  },
  data: function data() {
    return {
      loading: false,
      titleText: '',
      drawer: false,
      form: {},
      menuIds: [],
      menuIdsPDA: [],
      menuIdsPAD: [],
      mainTable: [],
      filterText: '',
      rules: {
        Role_Name: [{
          trigger: 'blur',
          required: true,
          message: this.$t('ManagerRole.askRoleName')
        }],
        Role_Type: [{
          trigger: 'blur',
          required: true,
          message: this.$t('ManagerRole.askRoletype')
        }]
      },
      defaultProps: {
        // 子级和显示的文字
        children: 'children',
        label: 'Menu_Name'
      },
      checkStrictly: false,
      checkStrictlyPDA: false,
      checkStrictlyPAD: false,
      routesData: [],
      routesDataPDA: [],
      routesDataPAD: [],
      activeName: 'menu',
      // 自定义报表
      REPORTMENUSIDS: [],
      ReportMainTable: [],
      defaultPropsReport: {
        children: 'children',
        label: 'REPORT_NAME'
      }
    };
  },
  methods: {
    clearInput: function clearInput() {
      this.getLoadData();
    },
    handleFilter: function handleFilter() {
      this.formData.Page = 1;
      this.getLoadData();
    },
    handleAddRole: function handleAddRole() {
      this.getOrModify();
      this.getOrModifyPDA();
      this.getOrModifyPAD();
      this.form = {
        Is_System: 'Y'
      };
      this.activeName = 'menu';
      this.drawer = true;
      this.checkStrictly = false;
      this.checkStrictlyPDA = false;
      this.checkStrictlyPAD = false;
      this.titleText = this.$t('ManagerRole.addRole');
    },
    // 获取角色列表
    getLoadData: function getLoadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return getRoutes(_this.formData);

              case 3:
                res = _context.sent;
                //   console.log(res.Result)
                _this.loading = false;

                if (res.code === 0) {
                  _this.mainTable = res.data;
                  _this.totalPage = res.TotalCount || 0;
                } else {
                  _this.mainTable = [];
                  _this.totalPage = 0;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 获取PC菜单路由
    getOrModify: function getOrModify(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!id) {
                  id = 0;
                }

                _context2.next = 3;
                return AddOrModify({
                  id: id,
                  menuKind: 'SCM',
                  terminal: 'PC'
                });

              case 3:
                res = _context2.sent;
                console.log('SCM菜单res', res);

                if (res.code === 0) {
                  _this2.routesData = res.data.RoleTreeList || [];
                  _this2.menuIds = res.data.MenuIds;

                  _this2.$nextTick(function () {
                    _this2.checkStrictly = false;
                  });
                } else {
                  _this2.$message.warning(res.message);

                  _this2.routesData = [];
                  _this2.menuIds = [];
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 获取PDA菜单
    getOrModifyPDA: function getOrModifyPDA(id) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!id) {
                  id = 0;
                }

                _context3.next = 3;
                return AddOrModify({
                  id: id,
                  menuKind: 'WMS',
                  terminal: 'PDA'
                });

              case 3:
                res = _context3.sent;

                if (res.Result) {
                  _this3.routesDataPDA = res.Result.RoleTreeList || [];
                  _this3.menuIdsPDA = res.Result.MenuIds;

                  _this3.$nextTick(function () {
                    _this3.checkStrictlyPDA = false;
                  });
                } else {
                  _this3.routesDataPDA = [];
                  _this3.menuIdsPDA = [];
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 获取PAD菜单
    getOrModifyPAD: function getOrModifyPAD(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!id) {
                  id = 0;
                }

                _context4.next = 3;
                return AddOrModify({
                  id: id,
                  menuKind: 'WMS',
                  terminal: 'PAD'
                });

              case 3:
                res = _context4.sent;

                if (res.Result) {
                  _this4.routesDataPAD = res.Result.RoleTreeList || [];
                  _this4.menuIdsPAD = res.Result.MenuIds;

                  _this4.$nextTick(function () {
                    _this4.checkStrictlyPAD = false;
                  });
                } else {
                  _this4.routesDataPAD = [];
                  _this4.menuIdsPAD = [];
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 菜单管理搜索
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.Menu_Name.indexOf(value) !== -1;
    },
    cancel: function cancel() {
      var _this5 = this;

      this.$confirm('已修改的不会保存，确认关闭？').then(function (_) {
        _this5.form = {};
        _this5.drawer = false;
        _this5.routesData = [];
        _this5.routesDataPDA = [];
        _this5.routesDataPAD = [];
        _this5.filterText = '';
      }).catch(function (_) {});
    },
    handleClose: function handleClose() {
      var _this6 = this;

      this.$confirm('已修改的不会保存，确认关闭？').then(function (_) {
        _this6.form = {};
        _this6.drawer = false;
        _this6.routesData = [];
        _this6.routesDataPDA = [];
        _this6.routesDataPAD = [];
        _this6.filterText = '';
      }).catch(function (_) {});
    },
    handleEdit: function handleEdit(scope) {
      this.form = scope.row;
      this.form.Remark = this.form.Remark === 'null' ? '' : this.form.Remark;
      this.drawer = true;
      this.activeName = 'menu';
      this.titleText = this.$t('ManagerRole.editRole');
      this.getOrModify(this.form.Id || 0); //   this.getOrModifyPDA(this.form.Id || 0)
      //   this.getOrModifyPAD(this.form.Id || 0)
      //   this.getLoadReportDataRoleId(this.form.Id || 0)

      this.checkStrictly = true; //   this.checkStrictlyPDA = true
      //   this.checkStrictlyPAD = true
      //   this.checkReportStrictly = true
    },
    onSubmit: function onSubmit() {
      var _this7 = this;

      var isEdit = this.titleText === this.$t('ManagerRole.editRole');
      var form = cloneDeep(this.form);
      var checkedKeys = this.$refs.tree.getCheckedKeys();
      var halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys(); // let checkedKeysPDA = this.$refs.treePDA.getCheckedKeys()
      // let halfCheckedKeysPDA = this.$refs.treePDA.getHalfCheckedKeys()
      // let checkedKeysPAD = this.$refs.treePAD.getCheckedKeys()
      // let halfCheckedKeysPAD = this.$refs.treePAD.getHalfCheckedKeys()
      // form.Menu_Ids = [...checkedKeys, ...halfCheckedKeys, ...checkedKeysPDA, ...halfCheckedKeysPDA, ...checkedKeysPAD, ...halfCheckedKeysPAD]

      form.Menu_Ids = [].concat(_toConsumableArray(checkedKeys), _toConsumableArray(halfCheckedKeys));
      form.MenuKind = 'SCM';
      this.$refs.role.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(valid) {
          var loading, response;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!valid) {
                    _context5.next = 6;
                    break;
                  }

                  loading = _this7.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                  _context5.next = 4;
                  return saveModifySave(form).catch(function () {
                    loading.close();
                  });

                case 4:
                  response = _context5.sent;

                  if (response.code === 0) {
                    // TODO 保存自定义报表菜单权限
                    // var postdata = this.$refs.reportTable.getRecordset()
                    // if (
                    //   postdata.insertRecords.length ||
                    //   postdata.removeRecords.length ||
                    //   postdata.updateRecords.length
                    // ) {
                    //   let ReportList = []
                    //   postdata.updateRecords.map((item, index) => {
                    //     let obj = {}
                    //     obj.REPORT_ID = item.ID
                    //     obj.ROLE_ID = form.Id
                    //     obj.CAN_SHOW = item.CAN_SHOW
                    //     obj.CAN_EXPORT = item.CAN_EXPORT
                    //     ReportList.push(obj)
                    //   })
                    //   await SaveReportPermission(ReportList)
                    // }
                    loading.close();

                    if (isEdit) {
                      _this7.$notify({
                        title: _this7.$t('ManagerRole.success'),
                        message: _this7.$t('ManagerRole.EditedSuccess'),
                        type: 'success',
                        duration: 2000
                      });
                    } else {
                      _this7.$notify({
                        title: _this7.$t('ManagerRole.success'),
                        message: _this7.$t('ManagerRole.addsuccess'),
                        type: 'success',
                        duration: 2000
                      });
                    }

                    _this7.formData.Page = 1;

                    _this7.getLoadData();

                    _this7.drawer = false;
                  } else {
                    loading.close();

                    _this7.$message.warning(response.Message);
                  }

                case 6:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.filterText = '';
    },
    // 删除
    handleDelete: function handleDelete(_ref2) {
      var _this8 = this;

      var $index = _ref2.$index,
          row = _ref2.row;
      this.$confirm(this.$t('ManagerRole.DeleteRole'), this.$t('ManagerRole.prompt'), {
        confirmButtonText: this.$t('ManagerRole.confirm'),
        cancelButtonText: this.$t('ManagerRole.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Delete(row.Id);

              case 2:
                response = _context6.sent;
                console.log('d', response);

                if (response.code === 0) {
                  _this8.$notify({
                    title: _this8.$t('ManagerRole.success'),
                    message: _this8.$t('ManagerRole.sudeleted'),
                    type: 'success',
                    duration: 2000
                  });

                  _this8.formData.Page = 1;

                  _this8.getLoadData();
                } else {
                  _this8.$notify({
                    title: _this8.$t('ManagerRole.prompt'),
                    message: response.message,
                    type: 'warning',
                    duration: 2000
                  });
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      })));
    },
    handleFormmateRemark: function handleFormmateRemark(_ref4) {
      var cellValue = _ref4.cellValue;
      return cellValue !== 'null' && cellValue ? cellValue : '';
    },
    // 获取全部自定义报表菜单数据
    getLoadReportDataRoleId: function getLoadReportDataRoleId(id) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res, data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return GetReportByRoleId(id);

              case 2:
                res = _context7.sent;

                if (res.Result) {
                  data = res.Result || [];
                  _this9.ReportMainTable = data;
                } else {
                  _this9.ReportMainTable = [];
                }

                console.log(_this9.ReportMainTable);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  },
  created: function created() {
    this.getLoadData();
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  }
};